module.exports = __webpack_public_path__ + "img/gorilla 4.jpg";